import { __extends } from "tslib";
import React from 'react';
import translations from '../translations.js';
import theme from '../styles/DefaultMainTheme';
import newThem from '../styles/DarkTheme';
export var PennyMacContext = /*#__PURE__*/React.createContext({
  theme: theme
});
var PnmacContext = /** @class */function (_super) {
  __extends(PnmacContext, _super);
  function PnmacContext(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      theme: theme,
      toggleTheme: function () {
        _this.setState({
          theme: theme == _this.state.theme ? newThem : theme
        });
      }
    };
    return _this;
  }
  PnmacContext.prototype.render = function () {
    return /*#__PURE__*/React.createElement(PennyMacContext.Provider, {
      value: this.state
    }, this.props.children);
  };
  return PnmacContext;
}(React.Component);
export default PnmacContext;